/* eslint-disable no-unused-vars */
import { ControllerModel } from "../_model/ControllerModel";
import { SingletonFlowchart } from "../_service/singletonFlowchart";
import { Vat } from "./modelVat";

class ControllerVat extends ControllerModel {
    constructor() {
        super("ControllerVat");

        this.setNewNode = (callback) => {
            let vat = new Vat();
            vat.decorate(callback);

            this.addNode(vat);
            SingletonFlowchart.SaveStatus()
        }

        this.loadNode = (node, callback) => {
            let vat = new Vat();
            vat.copyFrom(node);
            vat.decorate(callback);
            this.addNode(vat)
        }

        this.getProperties = async (node) => {
            let n = new Vat();
            await n.copyFrom(node);
            return n.data
        }

        this.getNode = (node) => {
            let n = new Vat();
            n.copyFrom(node);
            return n
        }
    }
}

export { ControllerVat };